/* eslint-disable no-console */
import {
  collection,
  doc,
  onSnapshot,
  addDoc,
  serverTimestamp
} from "firebase/firestore";
import { db } from "@/firebase";

const state = {
  transactions: []
};

const actions = {
  async loadTransactions({ commit, getters }, payload) {
    //commit("setLoadingPointsTable", true);
    const userId = payload;

    const programRef = doc(db(), "programs", getters.programId);
    const memberRef = doc(programRef, "members", userId);
    const transactionsRef = collection(memberRef, "transactions");

    onSnapshot(
      transactionsRef,
      querySnapshot => {
        let transactions = [];
        querySnapshot.forEach(doc => {
          transactions.push({
            id: doc.id,
            ...doc.data()
          });
        });
        commit("setTransactions", transactions);
      },
      error => {
        console.log(error);
      }
    );

    //commit("setLoadingPointsTable", false);
  },

  async addMemberPoints({ commit, getters, dispatch }, payload) {
    console.log("🔄 addMemberPoints called with:", payload);
    // required values in payload....
    // points: integer (can be positive or negative)
    // type: Award, Redeem, Adjust, Refund, Reorder
    // notes: 'description of the transaction. EG Admin'
    // description: 'description of the source transaction. EG Databucket name or Checkout, or Video or a value entered by the admin user'
    // memberId: the member firebase doc id
    console.log(payload);

    // Ensure points is a number but preserve negative values
    const safePayload = {
      ...payload,
      points: Number(payload.points) || 0 // Convert to number or default to 0 if invalid
    };

    const programRef = doc(db(), "programs", getters.programId);
    const memberRef = doc(programRef, "members", safePayload.memberId);
    const transactionsRef = collection(memberRef, "transactions");

    const transaction = {
      ...safePayload,
      created: serverTimestamp(),
      updated: serverTimestamp(),
      createdBy: safePayload.memberId,
      updatedBy: safePayload.memberId
    };

    try {
      await addDoc(transactionsRef, transaction);
    } catch (e) {
      throw "Error when creating a new transaction";
    }

    // try {
    //   await dispatch("updateMemberTotals", [payload.memberId]);
    // } catch (e) {
    //   throw "Error when updating member totals";
    // }
    //

    commit("setSnackbar", "Points added");

    return "ok";
  },

  async subtractMemberPoints({ commit, getters, dispatch }, payload) {
    // required values in payload....
    // points: integer (must be a positive value as it gets converted to negative below)
    // type: Award, Redeem, Adjust, Refund, Reorder
    // notes: 'description of the transaction. EG 3 reward items'
    // description: 'description of the source transaction. EG Databucket name or Checkout'
    // memberId: the member firebase doc id
    // console.log(payload)
    const programRef = doc(db(), "programs", getters.programId);
    const memberRef = doc(programRef, "members", payload.memberId);
    const transactionsRef = collection(memberRef, "transactions");

    const transaction = {
      ...payload,
      points: -Math.abs(payload.points),
      created: serverTimestamp(),
      updated: serverTimestamp(),
      createdBy: payload.memberId,
      updatedBy: payload.memberId
    };

    try {
      await addDoc(transactionsRef, transaction);
    } catch (e) {
      throw "Error when creating a new transaction";
    }

    // try {
    //   await dispatch("updateMemberTotals", [payload.memberId]);
    // } catch (e) {
    //   throw "Error when udating member points balances";
    // }
    //
    commit("setSnackbar", "Order submitted");

    return "ok";
  }
};

const mutations = {
  setTransactions(state, payload) {
    state.transactions = payload;
  }
};

const getters = {
  transactions(state) {
    return state.transactions;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
